<template>
  <b-modal
    id="modal-normative"
    centered
    :title="isEdit ? 'Редактировать ' : 'Добавить'"
    no-close-on-backdrop
    @show="openModal"
  >
    <validation-observer ref="PayersModal">
      <b-form-group label="Плательщик: " class="my-1">
        <validation-provider
          #default="{ errors }"
          name="плательщик "
          rules="required"
        >
          <b-form-input
            v-model="modalValue.title"
            placeholder="Введите плательщик "
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-form-group label="ИНН : " class="my-1">
        <validation-provider
          #default="{ errors }"
          name="инн"
          rules="required|integer"
        >
          <b-form-input
            v-model="modalValue.inn"
            placeholder="Введите инн"
            maxlength="14"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </validation-observer>
    <div>
      <b-form-checkbox
        class="custom-control-primary"
        name="check-button"
        id="checkbox-1"
        switch
        v-model="modalValue.is_active"
      >
        <span class="switch-icon-left">
          <feather-icon icon="CheckIcon" />
        </span>
        <span class="switch-icon-right">
          <feather-icon icon="XIcon" />
        </span>
      </b-form-checkbox>
    </div>

    <div slot="modal-footer">
      <b-button
        class="mx-1"
        variant="danger"
        @click="$bvModal.hide('modal-normative')"
      >
        {{ $t('client.cancel') }}
      </b-button>
      <b-button :variant="isEdit ? 'warning' : 'success'" @click="onSubmit">
        {{ isEdit ? $t('change') : $t('save') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BButton,
  BModal,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, integer, length } from '@validations'
import { mapActions } from 'vuex'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
  },

  data() {
    return {
      integer,
      length,
      id: '',
      modalValue: {
        title: '',
        is_active: true,
        inn: '',
      },
      required,
    }
  },

  props: {
    isEdit: {
      type: Boolean,
      required: true,
      default: false,
    },

    docTypeData: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },

  methods: {
    ...mapActions('knowledgeBase', ['CREATE_PAYER', 'UPDATE_PAYER']),

    openModal() {
      if (!this.isEdit) {
        this.modalValue.title = ''
        this.modalValue.is_active = true
        this.modalValue.inn = ''
      } else {
        this.modalValue.title = this.docTypeData.title
        this.modalValue.is_active = this.docTypeData.is_active
        this.modalValue.inn = this.docTypeData.inn
      }
    },

    async onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()

      const res = await this.$refs.PayersModal.validate()

      if (!res) {
        return
      }

      try {
        let ACTION = this.isEdit ? this.UPDATE_PAYER : this.CREATE_PAYER

        await ACTION({
          data: this.modalValue,
          id: this.docTypeData.id,
        })
        this.$emit('refresh')

        this.$nextTick(() => {
          this.$_successToast(this.$t('general.success'))
          this.$bvModal.hide('modal-normative')
        })
      } catch (error) {
        console.log('error', error)
      }
    },
  },
}
</script>

<style scoped>
#username {
  text-transform: uppercase;
}
</style>
